import * as React from 'react'
import * as RetentionPages from './components/retention/pages'
import { retentionReducer } from './components/retention/reducer'

export const SubscriptionContext = React.createContext()

export const SubscriptionProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(retentionReducer, { activePage: RetentionPages.FEEDBACK })
  const value = { state, dispatch }
  return (
    <SubscriptionContext.Provider value={value}>
      {children}
    </SubscriptionContext.Provider>
  )
}
